// Per-user row-density preference (data-table rule 03), kept in localStorage behind try/catch:
// private windows and blocked storage must never break the page.
import { warn } from '@/utils/debugLogger';

export const DENSITIES = Object.freeze({ COMPACT: 'compact', DEFAULT: 'default', COMFORTABLE: 'comfortable' });

export const DENSITY_OPTIONS = Object.freeze([
  { value: DENSITIES.COMPACT, icon: 'mdi-view-headline', title: 'Compact rows (40px)' },
  { value: DENSITIES.DEFAULT, icon: 'mdi-view-sequential', title: 'Default rows (48px)' },
  { value: DENSITIES.COMFORTABLE, icon: 'mdi-view-agenda', title: 'Comfortable rows (56px)' },
]);

export function isDensity(value) {
  return Object.values(DENSITIES).includes(value);
}

export function readDensity(storageKey) {
  try {
    const value = window.localStorage.getItem(storageKey);
    return isDensity(value) ? value : DENSITIES.DEFAULT;
  } catch (err) {
    warn('[densityPreference] localStorage unavailable, using the default density', err);
    return DENSITIES.DEFAULT;
  }
}

export function storeDensity(storageKey, value) {
  try {
    window.localStorage.setItem(storageKey, value);
  } catch (err) {
    warn('[densityPreference] could not persist the density preference', err);
  }
}
